import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { memo, ReactElement } from 'react';

type AurTopNavProps = {
  children?: ReactElement | ReactElement[];
};

const AurTopNav = (props: AurTopNavProps) =>
(<Grid
  container
  direction="row"
  sx={{
    justifyContent: 'space-between',
    alignItems: 'center',
  }}
  className={`aur-header`}
  data-testid="scroll-container"
>
  <Box className={'nav-logo-text-container'}>
    <Typography className="heading typo-text headline2_size logo-text">
      {t('app.logoNameTitle')}
    </Typography>
    <img
      src="/assests/images/consilio_logo.svg"
      alt="Consilio Logo"
      height={30}
      width={28}
      aria-hidden="true"
    />
    <img
      className={'img-subtitle'}
      src="/assests/images/by_consilio.svg"
      alt="By Consilio"
      aria-hidden="true"
    />
  </Box>
  <Box>{props.children}</Box>
</Grid>)


export default memo(AurTopNav);
